import { takeLatest } from 'redux-saga';
import { put, take, call, fork, select } from 'redux-saga/effects';
import { fromJS } from 'immutable';

import { TEAM_MEMBER, INFLUENCER, TALENT_AGENT, PRODUCTION_COMPANY } from '../../utils/static-configuration';
import { getCampaign, getFastLoadCampaign } from '../../utils/jsonapi-functions/campaigns2';
import {
  getCampaignPermissionOrganisationId,
  getCampaignPermissionId,
  getCampaignPermissionName,
  getCampaignPermissionRole,
  getPermissionListLoading,
} from '../../selectors/campaign-permission-selectors';
import { getCampaignLoading } from '../../selectors/campaign-selectors';
import { loadAuthToken } from '../../sagas/auth-token';
import { reportError } from '../../utils/error-handling-service';

import {
  LOAD_CAMPAIGN,
  LOADING_CAMPAIGN,
  LOAD_CAMPAIGN_SUCCESS,
  LOAD_CAMPAIGN_ERROR,
  SET_MY_PERMISSION_INFO,
} from './constants';
import { LOAD_CAMPAIGNS_SUCCESS } from '../influencers-campaign-list/constants';
import { LOAD_MEMBERS_SUCCESS } from '../campaign-members-manage/constants';

export function* loadCampaign(actions) {
  const { campaignId, fastLoad } = actions;

  try {
    yield call(loadAuthToken);

    const campaignLoading = yield select(getCampaignLoading);
    if (!campaignLoading) {
      if (!actions.silent) {
        yield put({ type: LOADING_CAMPAIGN });
      }

      const campaign = fastLoad ? yield call(getFastLoadCampaign, campaignId)
        : yield call(getCampaign, campaignId);

      // If the permissions list isn't loaded yet then wait for it to finish
      const campaignPermissionLoading = yield select(getPermissionListLoading);
      if (campaignPermissionLoading) {
        yield take(LOAD_CAMPAIGNS_SUCCESS);
      }

      const myCampaignOrganisationId = yield select(
        getCampaignPermissionOrganisationId,
        campaignId,
      );
      const myPermissionId = yield select(getCampaignPermissionId, campaignId);
      const myCampaignRole = yield select(
        getCampaignPermissionRole,
        campaignId,
      );
      const myPermissionName = yield select(
        getCampaignPermissionName,
        campaignId,
      );

      campaign.members = campaign.members || [];
      const members = {};
      const pendingMembers = {};
      campaign.members.forEach(member => {
        if (!member) return;
        members[member.id] = member;
      });

      campaign.pendingInvitations = campaign.pendingInvitations || [];

      // TODO This could be improved massively by simply storing the pending list as invidation IDs in the discussions
      campaign.pendingInvitations.forEach(pendingMember => {
        if (!pendingMember) return;
        const role = pendingMember.role;
        if (role === TEAM_MEMBER) {
          if (pendingMembers[campaign.owner.id]) {
            pendingMembers[campaign.owner.id] = [
              ...pendingMembers[campaign.owner.id],
              pendingMember,
            ];
          } else {
            pendingMembers[campaign.owner.id] = [pendingMember];
          }
        }

        if (pendingMember.organisation && (role === INFLUENCER || role === TALENT_AGENT || role === PRODUCTION_COMPANY)) {
          if (pendingMembers[pendingMember.organisation.id]) {
            pendingMembers[pendingMember.organisation.id] = [
              ...pendingMembers[pendingMember.organisation.id],
              pendingMember,
            ];
          } else {
            pendingMembers[pendingMember.organisation.id] = [pendingMember];
          }
        }
      });

      yield put({
        type: SET_MY_PERMISSION_INFO,
        role: myCampaignRole,
        id: myPermissionId,
        name: myPermissionName,
        organisationId: myCampaignOrganisationId,
      });

      yield put({ type: LOAD_CAMPAIGN_SUCCESS, campaign: fromJS(campaign) });

      yield put({
        type: LOAD_MEMBERS_SUCCESS,
        members: fromJS(members),
        pendingInvitations: fromJS(pendingMembers),
      });
    }
  } catch (error) {
    console.error(error);
    reportError('LOAD_CAMPAIGN_ERROR', error.message);
    yield put({ type: LOAD_CAMPAIGN_ERROR, error: error.message });
  }
}

export function* watchCampaign() {
  yield takeLatest(LOAD_CAMPAIGN, loadCampaign);
}

export default function* campaignSagas() {
  yield [fork(watchCampaign)];
}



/** WEBPACK FOOTER **
 ** ./src/containers/campaign/sagas.js
 **/